import {
  UnrecoverableErrorEntry,
  UnrecoverableErrorRawEntry,
} from '@/pages/UnrecoverableError/types'

export const parser = (
  entry: UnrecoverableErrorRawEntry,
): UnrecoverableErrorEntry => ({
  header: entry.header,
  instructions: entry.instructions.map((i) => i.instruction),
  errorLabel: entry.error.label,
  errorNote: entry.error.note,
  exitSetupButton: entry.buttons.find(
    (button) => button.action === 'exit-setup',
  )?.text,
})
